import React, {useState} from "react"
import passwordData from "./passwordData"

function PasswordCheck(props) {
    const [inputText, setInputText] = useState("")
    const [passwordHint] = useState(<h3><em>Check the "Investigation Log" - Larry</em></h3>)
    
    function handleChange(event) {
        const {value} = event.target
        setInputText(value)
    }
    
    function submitPassword(event) {
        event.preventDefault()
        const {value} = event.target
        const passwordCheck = value.toLowerCase()
        if (passwordCheck === passwordData[props.currentPage]) {
            props.callBackUnlock("unlocked")
        } else {
            alert("Password Incorrect")
            setInputText("")
        }   
    }
    
    return(
        <main>
            <h1 className="mainTitle">Enter The Password To Access This Part Of The Investigation</h1>
            
            <form className="passwordForm">
                <input placeholder="Enter Password" type="text" id="passwordInput" name="passwordInput" autoComplete="off" value={inputText} onChange={handleChange}/>
                <button className="standardButton" id="passwordButton" value={inputText} onClick={submitPassword}>Submit</button>
                {props.currentPage === 1 ? passwordHint : ""}
            </form>
            
            <div id="mainCornerCut"></div>
        </main>
    )
}

export default PasswordCheck